import { Field } from "forms"
import { Step } from "./types"

export function defineStep<Fields extends readonly Field[], ID extends string>(step: Step<Fields, ID>) {
    return step
}
